/**
 * Realistic browser window chrome wrapping a website screenshot.
 */
export default function BrowserFrame({ src, url = "www.beispiel.de", alt = "", className = "", imgClassName = "" }) {
  return (
    <div className={`overflow-hidden rounded-xl border border-black/10 bg-white browser-shadow ${className}`}>
      <div className="flex items-center gap-2 border-b border-black/5 bg-[#f3f1ec] px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-[#ff5f57]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#febc2e]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#28c840]" />
        <div className="ml-3 flex-1 truncate rounded-md bg-white px-3 py-1 font-mono text-[10px] text-[#8a857b]">
          {url}
        </div>
      </div>
      <div className="overflow-hidden bg-white">
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className={`block w-full object-cover object-top ${imgClassName}`}
        />
      </div>
    </div>
  );
}
